import React from 'react'
import { LinearProgress } from '@material-ui/core'

export default class Loader extends React.Component {
  render () {
    return <LinearProgress/>
  }
}
